import { render, staticRenderFns } from "./activeDialog.vue?vue&type=template&id=1f8a3a26"
import script from "./activeDialog.vue?vue&type=script&lang=js"
export * from "./activeDialog.vue?vue&type=script&lang=js"
import style0 from "./activeDialog.vue?vue&type=style&index=0&id=1f8a3a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports